// extracted by mini-css-extract-plugin
module.exports = {"base":"SelectInputFilter_base__3UcXl"};